import React from "react";
import { Component } from "react";
import ButtonIcon from "../../button";
import { TYPE_FUNCTION } from "../../../constants/external-constants";
export default class CustomDropdownButton extends Component {
    constructor(props) {
        super(props);
        this.state={
            toggle: false
        }
        this.buttonRef = React.createRef();
    }
    
    componentDidMount() {

        document.addEventListener('click', this.handleDocumentClick);

    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDocumentClick);
    }


    handleDocumentClick = (event) => {
        if (this.buttonRef.current && !this.buttonRef.current.contains(event.target)) {
          this.setState({ toggle: false });

        }
    };

    handleClickList=(id)=>{
        if (typeof this.props.onSelect === TYPE_FUNCTION) {  
            this.props.onSelect(id)
        }
    }
    render(){
        const {customClassName, extractListLabel, options }=this.props
        return(
            <div className={`custom-dropdown-button-container ${customClassName}`} ref={this.buttonRef}>
                <ButtonIcon onClick={() => this.setState((prev) => ({ toggle: !prev.toggle }))}  iconLeft="cloud-arrow-down" iconSize="17px" customClassName="header-filter-button header-option-list" labelName={extractListLabel}/>
                <div className="custom-dropdown-list">
                {
                    this.state.toggle &&
                    <ul>
                        {
                            options.map((list,index)=>{
                                return(
                                    <li key={index} onClick={()=>{this.handleClickList(list.id)}}>{list.label}</li>
                                )
                            })
                        }
                    </ul>
                }                    
                </div>
            </div>
        )
    }
}